import React from "react";
import { UserRoles } from "../../enums/userRoles";
import { datetime } from "../../utils/datetime";

const HeaderListButtons = (props) => {
    const {
        showGenerationButton,
        user,
        styles,
        params,
        pushModal,
        i18n,
        reload,
        RegularButton,
        showRefreshButton,
        endPointToRequest,
    } = props;
    const validateUser = [
        UserRoles.ADMIN,
        UserRoles.OWNER,
        UserRoles.WRITER,
        UserRoles.PP_SUPPORT,
        UserRoles.SUPPORT,
    ].includes(user.role);
    return (
        <>
            {showGenerationButton && validateUser && (
                <div>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <RegularButton
                            primary
                            icon="success"
                            children={i18n("SAF-T Generation")}
                            className={`${styles["simple-button"]} ${styles["btn-mark-active"]}`}
                            onClick={() => {
                                pushModal({
                                    title: "GENERATE SAF-T",
                                    data: {
                                        projectId: params.projectId,
                                        endPointToRequest: endPointToRequest || undefined,
                                    },
                                    args: params,
                                    view: "GenericGeneratorForm",
                                })
                                    .then(() => reload && reload())
                                    .catch(() => null);
                            }}
                        />
                    </div>
                </div>
            )}
            {showRefreshButton && validateUser && (
                <div className={styles["actions-buttons"]}>
                    <div>
                        <RegularButton
                            icon="refresh"
                            onClick={() => reload && reload()}
                            iconClassName={`${styles["small-background-color"]}`}
                            className={`${styles["simple-button"]} ${styles["btn-refresh"]} ${styles["btn-background-color"]}`}
                        />
                        <small
                            className={`${styles["btn-refresh"]} ${styles["small-background-color"]}`}
                        >
                            {i18n`Last update:`} {datetime(new Date())}
                        </small>
                    </div>
                </div>
            )}
        </>
    );
};

export default HeaderListButtons;
